export var createAbortError = function createAbortError() {
  return new DOMException('', 'AbortError');
};